module.exports = __webpack_public_path__ + "assets/img/Type E (5).dc01a117.jpg";